import {useMutation, useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type DebugPromptsPayload = {
  issue_number: number
  twirp: {
    developer_prompt: string
    user_prompt: string
  }
}

export type DebugSubmitPayload = {
  issue_number: number
  developer_prompt: string
  user_prompt: string
}

export function useLoadDebugPrompts(repoOwner: string, repoName: string, issueNumber: number, enabled: boolean) {
  const apiUrl = `/${repoOwner}/${repoName}/triage-agent/debug`

  return useQuery({
    queryKey: ['triage-agent-debug-prompts', apiUrl, issueNumber],
    queryFn: async () => {
      const response = await verifiedFetchJSON(`${apiUrl}?issue_number=${issueNumber}`)
      if (!response.ok) {
        throw new Error('Failed to fetch debug prompts')
      }
      return response.json() as Promise<DebugPromptsPayload>
    },
    enabled,
  })
}

export function useSubmitDebugTriage(repoOwner: string, repoName: string) {
  const apiUrl = `/${repoOwner}/${repoName}/triage-agent/debug`

  return useMutation({
    mutationFn: async (payload: {issueNumber: number; developerPrompt?: string; userPrompt?: string}) => {
      const body: DebugSubmitPayload = {
        issue_number: payload.issueNumber,
        developer_prompt: payload.developerPrompt ?? '',
        user_prompt: payload.userPrompt ?? '',
      }

      const response = await verifiedFetchJSON(apiUrl, {
        method: 'POST',
        body,
      })
      if (!response.ok) {
        throw new Error('Failed to submit debug triage')
      }
      return response.json() as Promise<{status: string}>
    },
  })
}
